import { useContext } from 'react';

import UserContext from 'src/contexts/UserContext';

const useUser = () => useContext(UserContext);

export default useUser;
